import { CommonModule, NgIf } from '@angular/common';
import { RouterModule } from '@angular/router';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { Toast } from 'bootstrap';
import { fromEvent, take } from 'rxjs';
import { ThemeService } from '../../services/theme.service';
import { ToastEventTypes } from '../../services/toast.service';


@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, NgIf, RouterModule ],
  styles: [],
  template: `<div
    #toastElement
    class="toast fade toast-width mt-2 "
    [ngClass]="type"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="toast-header">
      <strong class="me-auto">{{ title }}</strong>
      <small class="text-body-secondary">just now</small>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="hide()"
      ></button>
    </div>
    <div class="toast-body" *ngIf="message"  [ngStyle]="{'color': type == 'warning'?'black':'ghostwhite'}">{{ message }}</div>
  </div>`,
})
export class ToastComponent implements OnInit {
  // themeService = inject(ThemeService);
  @Output() disposeEvent = new EventEmitter();

  @ViewChild('toastElement', { static: true })
  toastEl!: ElementRef;

  @Input()
  type!: ToastEventTypes;

  @Input()
  title!: string;

  @Input()
  message!: string;

  toast!: Toast;

  ngOnInit() {
    this.show();
  }

  show() {
    this.toast = new Toast(
      this.toastEl.nativeElement,
      this.type === ToastEventTypes.Error
        ? {
            autohide: false,
          }
        : {
            delay: 5000,
          }
    );

    fromEvent(this.toastEl.nativeElement, 'hidden.bs.toast')
      .pipe(take(1))
      .subscribe(() => this.hide());

    this.toast.show();
  }

  hide() {
    this.toast.dispose();
    this.disposeEvent.emit();
  }
}
